import React from 'react'
import Header from './Components/Header';
import ContactUsComp from './Components/ContactUsComp';
import Footer from './Components/Footer';


function ContactUs() {

    return (
        <div>
            <Header />
            <ContactUsComp />
            <Footer />
        </div>
    )
}

export default ContactUs
